var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container referrals-page"},[_c('portal',{attrs:{"to":"page-name"}},[_vm._v("Solicitantes / Indicações")]),_c('div',{staticClass:"card card-page"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('referral-list')],1)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h1',{staticClass:"card-title"},[_vm._v("Solicitantes / Indicações")])])
}]

export { render, staticRenderFns }